{
  "longPressMessage": "Prima e mantenha premido para abrir a pré-visualização"
}
